<template>
    <div v-if="total > 1" class="progress-bar">
        <div class="progress-bar__number">1</div>
        <div class="progress-bar__wrapper">
            <div v-for="step in total" 
                :key="step" 
                :class="['progress-bar__dot', {'progress-bar__dot--active': step <= current}]"
            >
            </div>
        </div>
        <div class="progress-bar__number">{{ total }}</div>
    </div>
</template>

<script>
export default {
    name: 'ProgressBar',
    props: {
        total: {
            type: Number,
            required: true,
            default: 2
        },
        current: {
            type: Number,
            required: true,
            default: 1
        }
    }
}
</script>
